import { 
  Medal, 
  ShieldCheck, 
  Lightning, 
  Lightbulb, 
  Handshake, 
  Scales 
} from "@phosphor-icons/react";

const values = [
  {
    icon: Medal,
    title: "Calidad",
    description: "Entendemos la calidad como la correcta ejecución desde el primer momento. Cuidamos cada detalle técnico, operativo y administrativo.",
    color: "#C92127"
  },
  {
    icon: ShieldCheck,
    title: "Seguridad",
    description: "La seguridad no es un requisito, es parte de nuestra cultura. Protegemos a nuestros colaboradores, clientes e instalaciones.",
    color: "#1E3A8A"
  },
  {
    icon: Lightning,
    title: "Eficiencia",
    description: "Administramos adecuadamente tiempo, recursos y procesos para ejecutar proyectos con productividad.",
    color: "#EA580C"
  },
  {
    icon: Lightbulb,
    title: "Innovación",
    description: "Buscamos constantemente mejores formas de trabajar. Incorporamos nuevas metodologías y soluciones técnicas.",
    color: "#059669"
  },
  {
    icon: Handshake,
    title: "Compromiso",
    description: "Asumimos cada proyecto con responsabilidad total. Cumplimos lo prometido y construimos relaciones de largo plazo.",
    color: "#7C3AED"
  },
  {
    icon: Scales,
    title: "Integridad",
    description: "Actuamos con transparencia, ética y respeto en todas nuestras relaciones comerciales, laborales y operativas.",
    color: "#0891B2"
  }
];

export function ValuesSection() {
  return (
    <section
      data-testid="values-section"
      className="section-padding bg-white relative overflow-hidden"
    >
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-12 h-0.5 bg-[#C92127]" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Valores Corporativos
            </span>
            <span className="w-12 h-0.5 bg-[#C92127]" />
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6">
            Principios que guían <span className="text-[#C92127]">cada proyecto</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Nuestros valores corporativos definen cómo trabajamos y nos relacionamos 
            con nuestros clientes, colaboradores y comunidad.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={value.title}
                data-testid={`value-card-${value.title.toLowerCase()}`}
                className="group p-8 rounded-xl border border-slate-200 hover:border-transparent hover:shadow-xl transition-all duration-300 bg-white relative overflow-hidden"
              >
                {/* Background Gradient on Hover */}
                <div 
                  className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity"
                  style={{ backgroundColor: value.color }}
                />

                {/* Icon */}
                <div 
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110"
                  style={{ backgroundColor: `${value.color}15` }}
                >
                  <Icon size={32} weight="duotone" style={{ color: value.color }} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-[#C92127] transition-colors">
                  {value.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {value.description}
                </p>

                {/* Number */}
                <span 
                  className="absolute top-6 right-6 text-6xl font-extrabold opacity-5"
                  style={{ color: value.color }}
                >
                  0{index + 1}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default ValuesSection;
